import { usePrefetchComprehensiveReport } from "services/hooks/rentals";

/**
 * After login: daily_summary + dashboard run from Dashboard hooks first.
 * Comprehensive report prefetches in the background once those finish (or after max wait).
 */
const BackgroundReportPrefetch = () => {
	usePrefetchComprehensiveReport({ enabled: true, waitForCritical: true });
	return null;
};

export default BackgroundReportPrefetch;
